import { useSearchParams } from 'react-router-dom';
import { NotFoundPanel } from '@/components/feedback/not-found-panel';
import { parseSubjectKey } from '@/features/abuse/abuse-meta';
import { SubjectPage } from '@/features/abuse/subject/subject-page';

const AbuseSubjectPage = () => {
  const [searchParams] = useSearchParams();
  const subjectKey = parseSubjectKey(searchParams);

  if (!subjectKey) return <NotFoundPanel message="The link is missing a valid subject type or id." title="Subject not found" />;

  // key resets the page when following a linked subject
  return <SubjectPage key={`${subjectKey.subjectType}|${subjectKey.subjectId}`} subjectKey={subjectKey} />;
};
AbuseSubjectPage.displayName = 'AbuseSubjectPage';

export default AbuseSubjectPage;
